import React from 'react';
import ReactDOMServer from 'react-dom/server';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCrown } from '@fortawesome/free-solid-svg-icons';
import themeVariables from '~/shared/themeVariables';
import { makeSelectProfile } from '~/containers/AuthProvider/selectors';
import withI18next from '~/../hocs/_withI18next';
import Config from '~/config';
import { makeSelectPhotoAssets } from '~/containers/PhotoPage/selectors';
import I18nLink from '~/components/I18nLink';

const roles = Config.getRoles();

const AssetTypes = ({ assets }) =>
  assets.map((item) => (
    <span key={item.type} className={`asset-type ${Config.serviceType}`}>
      {item.type}
    </span>
  ));

const PremiumHint = withI18next()(({ t, lng, assets, profile }) => {
  if (profile.role === roles.PREMIUM) return null;

  const premiumAssets = assets.filter(
    (item) => item.price && item.price.with_tax !== 0,
  );
  if (premiumAssets.length === 0) return null;

  const assetTypes = ReactDOMServer.renderToString(
    <AssetTypes assets={premiumAssets} />,
  );
  return (
    <div className="premium-hint">
      <div
        className="text-hint"
        dangerouslySetInnerHTML={{
          __html: t('how_to_make_assets_free', { assetTypes }),
        }}
      />
      <I18nLink href="/premium">
        <a
          // className={`btn btn-ac-primary-outline btn-${Config.serviceType} btn-upgrade`}
          className={'btn-upgrade-premium'}
        >
          <FontAwesomeIcon
            style={{ marginRight: 7, width: 18 }}
            icon={faCrown}
          />
          <div className="text-upgrade">{t('upgrade_now')}</div>
        </a>
      </I18nLink>

      <style jsx>
        {`
          .btn-upgrade-premium {
            display: flex;
            background: #fff;
            font-size: 14px;
            text-align: center;
            flex: 1;
            justify-content: center;
            padding: 8px 16px;
            color: ${themeVariables.colors.primary};
            border: 1px solid ${themeVariables.colors.primary};
            cursor: pointer;
            border-radius: 2px;
          }
          .btn-upgrade-premium:hover {
            color: #ffff;
            border: 1px solid ${themeVariables.colors.primary};
            background: ${themeVariables.colors.primary};
          }
          @media (max-width: ${themeVariables.breakpoints.mobile.maxWidth}px) {
            .btn-upgrade-premium {
              margin-top: 16px;
            }
          }
        `}
      </style>
      <style jsx global>
        {`
          .premium-hint {
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            border: 1px solid #dcdcdc;
            padding: 16px 32px;
            border-radius: 2px;
            background: #fff;
            margin-top: 14px;
          }
          .premium-hint .text-hint {
            font-size: 18px;
            font-weight: bold;
            margin-right: 56px;
          }
          .premium-hint .asset-type {
            border: 1px solid;
            padding: 2px 4px;
            color: white;
            border-radius: 2px;
            margin: 0 1px;
          }
          .premium-hint .asset-type:first-child {
            margin-left: 5px;
          }
          .premium-hint .asset-type:last-child {
            margin-right: 5px;
          }
          .premium-hint .asset-type.photo_ac {
            background: #509bdc;
          }
          .premium-hint .asset-type.illust_ac {
            background: #d73a4e;
          }
          .premium-hint .asset-type.silhouette_ac {
            background: #41b9b8;
          }
          .premium-hint .asset-type.design_ac {
            background: #ffa823;
          }
          .premium-hint .btn-upgrade {
            flex: 1;
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
          }
          .premium-hint .btn-upgrade .icon-premium {
            margin-right: 14px;
          }
          .premium-hint .btn-upgrade .text-upgrade {
            margin-top: 2px;
          }

          @media (max-width: ${themeVariables.breakpoints.tabletL.maxWidth}px) {
            .premium-hint {
              padding: 16px;
            }
          }

          @media (max-width: ${themeVariables.breakpoints.mobile.maxWidth}px) {
            .premium-hint {
              padding: 16px;
              flex-direction: column;
              align-items: center;
            }

            .premium-hint .text-hint {
              margin-right: 0;
            }

            .premium-hint .btn-upgrade {
              margin-top: 16px;
            }
          }
        `}
      </style>
    </div>
  );
});

const mapStateToProps = createStructuredSelector({
  assets: makeSelectPhotoAssets(),
  profile: makeSelectProfile(),
});
export default connect(mapStateToProps)(PremiumHint);
